import Card from 'react-bootstrap/Card';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Accordion from 'react-bootstrap/Accordion';
import { ICONS } from 'Utils/icons';

//
// export const NextPage = ({ text, path }) => {
//
//
//
//     return (
//        <Row className="next-page-container d-flex p-0 pb-5">
//             <Col lg={11} className="next-page-container d-flex align-items-end pb-5 ps-3 pe-3">
//                 <Col  className="w-auto">
//                     <div className="mb-0"><span className="header2 semibold">Next:</span></div>
//                     <div>
//                         <a href={path} className="d-flex gap-2 align-items-center">
//                             <span>{text}</span>
//                             {ICONS.arrow()}
//                         </a>
//
//                     </div>
//                 </Col>
//             </Col>
//         </Row>
//     );
// }

export const NextPage = ({ text, path, backPath, backPathText }) => {
    const hasNext = Boolean(path && text);
    const hasBack = Boolean(backPath && backPathText);
    
    const justify =
      hasNext && hasBack
        ? "justify-content-between"
        : hasNext
          ? "justify-content-end"
          : "justify-content-start";
    
    return (
      <Row className="next-page-container m-0 p-0 py-4 align-items-center align-content-center">
          <Col lg={10} className="d-flex pb-5 ps-3 pe-3">
              <div
                className={`d-flex ${justify} w-100 gap-3 flex-column flex-sm-row align-items-stretch`}
              >
                  {hasBack && (
                    <div
                      className="order-2 order-sm-1 align-self-start align-self-sm-center text-start back-nav-container"
                      style={{ minWidth: 0 }}
                    >
                        <div className="mb-0">
                            <span className="header2 semibold">Back:</span>
                        </div>
                        <div>
                            <a
                              href={backPath}
                              className="d-inline-flex gap-2 align-items-center"
                              aria-label={`Go back to ${backPathText}`}
                            >
                                {typeof ICONS?.arrow === "function" ? ICONS.arrow() : <span aria-hidden="true">→</span>}
                                <span>{backPathText}</span>
                            </a>
                        </div>
                    </div>
                  )}
                  
                  {hasNext && (
                    <div
                      className="order-1 order-sm-2 align-self-end align-self-sm-center text-start"
                      style={{ minWidth: 0 }}
                    >
                        <div className="mb-0">
                            <span className="header2 semibold">Next:</span>
                        </div>
                        <div>
                            <a
                              href={path}
                              className="d-inline-flex gap-2 align-items-center"
                              aria-label={`Go to ${text}`}
                            >
                                <span>{text}</span>
                                {typeof ICONS?.arrow === "function" ? ICONS.arrow() : <span aria-hidden="true">→</span>}
                            </a>
                        </div>
                    </div>
                  )}
              </div>
          </Col>
      </Row>
    );
};